import { nextTick } from 'vue'
import { lang as langRef, langs } from './lang'

function changeLanguageCallback(lang?: string) {
  if (lang) {
    langRef.value = langs.includes(lang) ? lang : langs[0]
  } else {
    langRef.value = langs[(langs.indexOf(langRef.value) + 1) % langs.length]
  }
}

export function changeLanguage(lang?: string) {
  setTimeout(() => changeLanguageCallback(lang), 1)
}
